import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPrivateRedEnvelope,
  getRedEnvelope,
  getRedEnvelopeRecord,
  getTransferMoneyRecord,
} from "@/api/modules/systemPay";

export const getRedEnvelopeAction = createAsyncThunk(
  "todayData/getRedEnvelope",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getRedEnvelope(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getRedEnvelopeRecordAction = createAsyncThunk(
  "todayData/getRedEnvelopeRecord",
  async (recordId: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getRedEnvelopeRecord(recordId);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getPrivateRedEnvelopeAction = createAsyncThunk(
  "todayData/getPrivateRedEnvelope",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getPrivateRedEnvelope(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);

export const getTransferMoneyRecordAction = createAsyncThunk(
  "todayData/getTransferMoneyRecord",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result = await getTransferMoneyRecord(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);



